import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import { DevopstrioAuthProvider } from "./context/DevopstrioAuthContext";
import DevopstrioProtectedRoute from "./routes/DevopstrioProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MaintenanceNoticeSlider from "./components/MaintenanceNoticeSlider";
import MaintenanceBlocker from "./components/MaintenanceBlocker";
import GlobalMeetingReminder from "./components/GlobalMeetingReminder";
import FaviconUpdater from "./components/FaviconUpdater";
import ScrollToTop from "./layout/ScrollToTop";

import Home from "./pages/Home";
import Search from "./pages/Search";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import UserVerification from "./pages/UserVerification";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import About from "./components/About";
import Contact from "./components/Contact";
import RegisterSolicitorTour from "./pages/RegisterSolicitorTour";
import UserAgreementSign from "./pages/UserAgreementSign";
import SolicitorDashboard from "./pages/SolicitorDashboard";
import SolicitorProfile from "./pages/SolicitorProfile";
import SolicitorDetail from "./pages/SolicitorDetail";
import BookAppointment from "./pages/BookAppointment";
import UserDashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import LegalInsights from "./components/LegalInsights";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import CookiesPolicy from "./components/CookiesPolicy";
import Faq from "./components/FAQ";
import CaseProcessGuides from "./components/CaseProcessGuides";
import PracticeAreas from "./components/PracticeAreas";
import DevopstrioLogin from "./pages/DevopstrioLogin";
import DevopstrioDashboard from "./pages/DevopstrioDashboard";
import NotFound from "./pages/NotFound";
import Subscription from "./pages/Subscription";
import CreateSubscription from "./pages/CreateSubscription";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <MaintenanceBlocker />
        <MaintenanceNoticeSlider />
        <ToastContainer position="top-right" autoClose={2500} />
        <GlobalMeetingReminder />
        <FaviconUpdater />
        <ScrollToTop />
        <Routes>
          {/* =======================
              Public Routes
          ======================= */}
          <>
            <Route path="/" element={<Home />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/verify" element={<UserVerification />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/search" element={<Search />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/solicitor/:id" element={<SolicitorDetail />} />
            <Route path="/book-appointment/:solicitorId" element={<BookAppointment />} />

            <Route path="/register-solicitor" element={<RegisterSolicitorTour />} />
            <Route path="/user/agreements/:agreementId/sign" element={<UserAgreementSign />} />

            <Route path="/legal-insights" element={<LegalInsights />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/cookies" element={<CookiesPolicy />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/case-guides" element={<CaseProcessGuides />} />
            <Route path="/practice-areas" element={<PracticeAreas />} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/subscription/checkout" element={<CreateSubscription />} />
            <Route path="/devopstriologin" element={<DevopstrioLogin />} />
            <Route path="/devopstrio/dashboard"
              element={
                <DevopstrioProtectedRoute>
                  <DevopstrioDashboard />
                </DevopstrioProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </>


          {/* =======================
          Protected Routes
          ======================= */}
          {[
            { path: "/solicitor/dashboard", element: <SolicitorDashboard /> },
            { path: "/solicitor/profile", element: <SolicitorProfile /> },
            { path: "/user/dashboard", element: <UserDashboard /> },
            { path: "/admin/dashboard", element: <AdminDashboard /> }
          ].map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={
                <ProtectedRoute>
                  {element}
                </ProtectedRoute>
              }
            />
          ))}


        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
